export class Address {
    constructor(
        public id?: number,
        public address1?: string,
        public address2?: string,
    ) { }

    static adapt(item: any): Address {
        return new Address(
            item.id,
            item.address1,
            item.address2
        );
    }
}
